(function (Account, $, undefined) {

  var $hull = '',
      hullCheck = '';

  var hullTimeout = function() { //moving hull where we want it
      $hull = $('[data-hull-ship]');
      if($hull.length > 0) {
          $hull.prependTo('#js-social-login');
          window.clearTimeout(hullCheck);
      } else {
          hullCheck = window.setTimeout(function(){
              hullTimeout();
          },500);
      }
  };

  var checkForErrors = function() {
    for (var i = 0; i < $('.account-form').length; i++) {
      var $curr = $('.account-form').eq(i);
      if(($curr.find('.errors').length || $curr.find('.confirmation').length) && !$curr.is(':visible')) {
        $curr.slideDown(200).siblings().slideUp(200);
      }
    }
  };

  var bindUIActions = function(){
    $('.js-switch-form').on('click',function(){
      $(this).parents('.account-form').slideUp(200).siblings().slideDown(200);
      return false;
    });
  };


  Account.init = function () {
    hullTimeout();
    checkForErrors();
    bindUIActions();
  };

}(window.Account = window.Account || {}, jQuery));
